import cn from 'classnames';
import type { HTMLAttributes } from 'react';
import * as st from './styles.module.scss';

type PT = HTMLAttributes<HTMLParagraphElement> & {
  error?: string;
};

export const ModalError = ({ error, className, ...props }: PT) => {
  return (
    error && (
      <p className={cn(st.error, className)} {...props}>
        {error}
      </p>
    )
  );
};
